var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',_vm._l((_vm.transitions),function(data){return _c('app-button',{on:{"click":function($event){return _vm.resolveTransition(data)}}},[_vm._v(_vm._s(data.label))])}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }